export enum TypeChamp
{
    Individual = 'individual',                              // Type client
    Professional = 'professional',                          // Type client
    NewVehicle = 'VN',                                      // Type lead
    UsedVehicle = 'VO',                                     // Type lead
    VDL = 'VDL',                                            // Type lead
    AfterSales = 'after_sales',                             // Type lead
    Automobile = 'automobile',                              // Activité
    Motorcycle = 'motorcycle',                              // Activité
    Recreational = "recreational_vehicle",                  // Activité
    Autobiz = 'autobiz',                                    // Catalogue
    Autovista = 'autovista',                                // Catalogue
    RecreationalReference = 'recreational_reference',       // Catalogue
    MotorcycleReference = 'motorcycle_reference',           // Catalogue
    MotorcycleManualEntry = 'motorcycle_manual_entry',      // Catalogue
    AutomobileManualEntry = 'automobile_manual_entry',      // Catalogue
    RecreationalManualEntry = 'recreational_manual_entry',  // Catalogue
    Kifal = 'kifal',                                        // Catalogue
}

export const TypeChampLabel: Record<TypeChamp, string> = {
    [TypeChamp.Individual]: 'Particulier',
    [TypeChamp.Professional]: 'Pro',
    [TypeChamp.NewVehicle]: 'VN',
    [TypeChamp.UsedVehicle]: 'VO',
    [TypeChamp.VDL]: 'VDL',
    [TypeChamp.Recreational]: "Loisirs",
    [TypeChamp.AfterSales]: 'APV',
    [TypeChamp.Automobile]: 'Automobile',
    [TypeChamp.Motorcycle]: 'Moto',
    [TypeChamp.Autobiz]: 'Autobiz',
    [TypeChamp.Autovista]: 'Autovista',
    [TypeChamp.RecreationalReference]: 'Referentiel VDL',
    [TypeChamp.MotorcycleReference]: 'Referentiel moto',
    [TypeChamp.MotorcycleManualEntry]: 'Saisie manuelle moto',
    [TypeChamp.AutomobileManualEntry]: 'Saisie manuelle auto',
    [TypeChamp.RecreationalManualEntry]: 'Saisie manuelle loisirs',
    [TypeChamp.Kifal]: 'Kifal',
}

export const TYPES_CHAMP: { code: TypeChamp, libelle: string }[] = Object.values(TypeChamp)
                                                                         .map(code => ({ code, libelle: TypeChampLabel[code] }))
